import React from 'react';
import * as FeatherIcon from 'react-feather';
import { Redirect, Route } from 'react-router-dom';

import { getActiveUser, isUserAuthenticated } from '../helpers/authUtils';
import BannerDetails from '../pages/apps/Banner/detail';
import IncubationApplicationList from '../pages/apps/incubationApplications/incubationList';
import AdminInternshipList from '../pages/apps/AdminInternship/registrationList';
import AdminInternshipDetails from '../pages/apps/AdminInternship/detail';
import AdvertisementList from '../pages/apps/Advertisement/advertisementList';
import InternshipApplicationList from '../pages/apps/internshipApplication/registrationList';
import InternshipApplicationDetails from '../pages/apps/internshipApplication/detail';
import PublicationDetails from '../pages/apps/Publications/detail';

// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const IncubationDetails = React.lazy(() => import('../pages/apps/incubationApplications/detail'));
const IncubationList = React.lazy(() => import('../pages/apps/incubation/registrationList'));
const AriseList = React.lazy(() => import('../pages/apps/arise/registrationList'));
const AriseDetails = React.lazy(() => import('../pages/apps/arise/detail'));
const AccelerationList = React.lazy(() => import('../pages/apps/acceleration/registrationList'));
const GrievanceRedressalDetails = React.lazy(() => import('../pages/apps/grievanceRedressal/detail'));
const AcademicDetails = React.lazy(() => import('../pages/apps/academicApplication/detail'));
const FacilitationDetails = React.lazy(() => import('../pages/apps/facilitation/detail'));
const AccelerationDetails = React.lazy(() => import('../pages/apps/acceleration/detail'));
const AspiringUser = React.lazy(() => import('../pages/apps/aspiringUser/registrationList'));
const AspiringDetails = React.lazy(() => import('../pages/apps/aspiringUser/detail'));
const SchoolDetails = React.lazy(() => import('../pages/apps/schools-colleges/registrationList'));
const SchoolList = React.lazy(() => import('../pages/apps/schools-colleges/detail'));
const ExistingDetails = React.lazy(() => import('../pages/apps/existingUser/detail'));
const ExistingUser = React.lazy(() => import('../pages/apps/existingUser/registrationList'));
const ResearchDetails = React.lazy(() => import('../pages/apps/researchUser/detail'));
const ResearchUser = React.lazy(() => import('../pages/apps/researchUser/registrationList'));
const IndustryDetails = React.lazy(() => import('../pages/apps/IndustryUser/detail'));
const IndustryList = React.lazy(() => import('../pages/apps/IndustryUser/registrationList'));
const ExpertDetails = React.lazy(() => import('../pages/apps/expertUser/detail'));
const ExpertList = React.lazy(() => import('../pages/apps/expertUser/registrationList'));
const EDClubList = React.lazy(() => import('../pages/apps/edclubUser/registrationList'));
const EDClubDetails = React.lazy(() => import('../pages/apps/edclubUser/detail'));
const StudentList = React.lazy(() => import('../pages/apps/student/registrationList'));
const GuestList = React.lazy(() => import('../pages/apps/guest/registrationList'));
const MatchDetails = React.lazy(() => import('../pages/apps/matchMaking/detail'));
const MatchList = React.lazy(() => import('../pages/apps/matchMaking/registrationList'));
const InternshipDetails = React.lazy(() => import('../pages/apps/internship/detail'));
const InternshipList = React.lazy(() => import('../pages/apps/internship/registrationList'));
const EventDetails = React.lazy(() => import('../pages/apps/events/detail'));
const EventList = React.lazy(() => import('../pages/apps/events/registrationList'));
const SchemeList = React.lazy(() => import('../pages/apps/schemes/registrationList'));
const SchemeDetails = React.lazy(() => import('../pages/apps/schemes/detail'));
const ProgramDetails = React.lazy(() => import('../pages/apps/Programs/detail'));
const ProgramBookingDetails = React.lazy(() => import('../pages/apps/Programs/bookingDetail'));
const ProgramList = React.lazy(() => import('../pages/apps/Programs/registrationList'));
const NewProgram = React.lazy(() => import('../pages/apps/NewProgram/detail'));
const EditProgram = React.lazy(() => import('../pages/apps/NewProgram/editDetails'));
const NewsDetails = React.lazy(() => import('../pages/apps/latestNews/detail'));
const NewsList = React.lazy(() => import('../pages/apps/latestNews/registrationList'));
const DepartmentList = React.lazy(() => import('../pages/apps/departments/registrationList'));
const DepartmentDetails = React.lazy(() => import('../pages/apps/departments/detail'));
const NewUserList = React.lazy(() => import('../pages/apps/newUser/registrationList'));
const districtList = React.lazy(() => import('../pages/apps/districts/registrationList'));
const NewPhotos = React.lazy(() => import('../pages/apps/Photos/PhotosList'));
const InternshipReportsList = React.lazy(() => import('../pages/apps/AdminReports/Internship/internship'));

const NewVideos = React.lazy(() => import('../pages/apps/Videos/registrationList'));
const NewMaterial = React.lazy(() => import('../pages/apps/Materials/registrationList'));
const NewApplications = React.lazy(() => import('../pages/apps/Publications/publicationList'));
const NewReports = React.lazy(() => import('../pages/apps/Reports/registrationList'));
const NewTender = React.lazy(() => import('../pages/apps/Tenders/registrationList'));
const NewCareer = React.lazy(() => import('../pages/apps/Careers/registrationList'));
const GrievanceRedressal = React.lazy(() => import('../pages/apps/grievanceRedressal/redressalList'));
const AcademicList = React.lazy(() => import('../pages/apps/academicApplication/registrationList'));
const InternshipReportsDetail = React.lazy(() => import('../pages/apps/AdminReports/Internship/details'));
const FacilitationList = React.lazy(() => import('../pages/apps/facilitation/registrationList'));
const NewMember = React.lazy(() => import('../pages/apps/Council/registrationList'));
const NewBanner = React.lazy(() => import('../pages/apps/Banner/bannerList'));
const NewTestimonial = React.lazy(() => import('../pages/apps/Testimonials/testimonialList'));
const listEDClub = React.lazy(() => import('../pages/apps/edclub/registrationList'));
const DetailEDClub = React.lazy(() => import('../pages/apps/edclub/detail'));
const QuestionList = React.lazy(() => import('../pages/apps/Questions/registrationList'));
const FeedbackList = React.lazy(() => import('../pages/apps/Feedback/FeedbackList'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const AboutKied = React.lazy(() => import('../pages/apps/aboutKied/aboutKiedList'));
const OurTeam = React.lazy(() => import('../pages/apps/ourTeam/ourTeamList'));
const RTI = React.lazy(() => import('../pages/apps/RTI/RTIList'));
const ActsRulesAndGOs = React.lazy(() => import('../pages/apps/ActsRulesGOrders/OrdersList'));
const NewPartner = React.lazy(() => import('../pages/apps/Partners/PartnersList'));
const ProgramReportsList = React.lazy(() => import('../pages/apps/AdminReports/Program/program'));
const ProgramReportsDetail = React.lazy(() => import('../pages/apps/AdminReports/Program/detail'));
const EventsReportsList = React.lazy(() => import('../pages/apps/AdminReports/Events/event'));
const EventsReportsDetail = React.lazy(() => import('../pages/apps/AdminReports/Events/details'));
const BannerDetail = React.lazy(() => import('../pages/apps/Banner/detail'));
const IncubationReportsList = React.lazy(() => import('../pages/apps/AdminReports/Incubation/incubation'));
const IncubationReportsDetail = React.lazy(() => import('../pages/apps/AdminReports/Incubation/detail'));
const FacilitationReportsList = React.lazy(() => import('../pages/apps/AdminReports/Facilitation/facilitation'));
const FacilitationReportsDetail = React.lazy(() => import('../pages/apps/AdminReports/Facilitation/detail'));
const IndustryAcademicReportsList = React.lazy(() => import('../pages/apps/AdminReports/IndustryAcademia/industryAcademia'));
const IndustryAcademicReportsDetail = React.lazy(() => import('../pages/apps/AdminReports/IndustryAcademia/detail'));
// dashboard
const Dashboard = React.lazy(() => import('../pages/dashboard'));

const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (!isUserAuthenticated()) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: '/account/login', state: { from: props.location } }} />;
            }

            const loggedInUser = getActiveUser();
            // check if route is restricted by role
            if (roles && roles.indexOf(loggedInUser?.role) === -1) {
                // role not authorised so redirect to home page
                return <Redirect to={{ pathname: '/' }} />;
            }

            // authorised so return component
            return <Component {...props} />;
        }}
    />
);

const loggedInForDept = getActiveUser();

// Dynamic department-based visibility using user's department_id
const userDepartmentId = loggedInForDept?.department_id ? Number(loggedInForDept.department_id) : null;
const userRole = loggedInForDept?.role;
const isSuperAdmin = userRole === 9;
const isDepartmentAdmin = userRole === 12;

const departmentList = (() => {
    try {
        return JSON.parse(localStorage.getItem('departments')) || [];
    } catch (error) {
        console.error('Failed to parse departments cache', error);
        return [];
    }
})();

const matchedDepartment = departmentList.find((dept) => Number(dept?.id) === userDepartmentId);
const departmentName = matchedDepartment?.name?.toLowerCase() || '';

const hasDepartmentName = (...keywords) =>
    keywords.some((keyword) => keyword && departmentName.includes(keyword.toLowerCase()));

// Dynamic visibility flags based on department list match
const showIncubation = isDepartmentAdmin && matchedDepartment && hasDepartmentName('incubation');
const showProgram =
    isDepartmentAdmin && matchedDepartment && hasDepartmentName('program', 'learning');
const showIndustryAcademic =
    isDepartmentAdmin && matchedDepartment && hasDepartmentName('industry', 'academic');
const showFacilitation = isDepartmentAdmin && matchedDepartment && hasDepartmentName('facilitation');

// Report visibility - show reports for respective departments
const showIncubationReport = showIncubation;
const showProgramReport = showProgram;
const showIndustryAcademicReport = showIndustryAcademic;
const showFacilitationReport = showFacilitation;

// For Programs menu visibility
const showAdminProgram = isSuperAdmin || showProgram;

const reportRoles = [9,];

// root routes
const rootRoute = {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />,
    route: PrivateRoute,
};

// dashboards
const dashboardRoutes = {
    path: '/dashboard',
    name: 'Dashboard',
    icon: FeatherIcon.Home,
    header: 'Menu',
    // badge: {
    //     variant: 'success',
    //     text: '1',
    // },
    component: Dashboard,
    roles: [9, 12, 13, 14, 15, 16],
    route: PrivateRoute,
};

const edclubRoute = {
    name: 'ED Club',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/edclub-list',
            name: 'ED CLub',
            component: listEDClub,
            route: PrivateRoute,
            roles: [9],
        },
    ],
};
// const incubationRoute = {
//     name: 'Incubation',
//     icon: FeatherIcon.Archive,
//     children: [
//         // {
//         //     path: '/incubation-registration-list',
//         //     name: 'Registrations ',
//         //     component: IncubationList,
//         //     route: PrivateRoute,
//         //     roles: [9],
//         // },
//         {
//             path: '/incubation-application-list',
//             name: 'Incubation Applications',
//             component: IncubationApplicationList,
//             route: PrivateRoute,
//             roles: [9],
//         },
//         // {
//         //     path: '/arise-registration-list',
//         //     name: 'Arise',
//         //     component: AriseList,
//         //     route: PrivateRoute,
//         //     roles: [9],
//         // },
//         // {
//         //     path: '/acceleration-registration-list',
//         //     name: 'Acceleration Program',
//         //     component: AccelerationList,
//         //     route: PrivateRoute,
//         //     roles: [9],
//         // },
//     ],
// };
const questionRoute = {
    name: 'Questions',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/question-list',
            name: 'Question-List',
            component: QuestionList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        // {
        //     path: '/arise-registration-list',
        //     name: 'Arise',
        //     component: AriseList,
        //     route: PrivateRoute,
        //     roles: [9],
        // },
        // {
        //     path: '/acceleration-registration-list',
        //     name: 'Acceleration Program',
        //     component: AccelerationList,
        //     route: PrivateRoute,
        //     roles: [9],
        // },
    ],
};

const iacRoute = {
    name: 'IAC',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/matchmaking-list',
            name: 'Match-Making ',
            component: MatchList,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/internship-list',
            name: 'Internship',
            component: InternshipList,
            route: PrivateRoute,
            roles: [9],
        },
    ],
};
const eventRoute = {
    name: 'Events',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/events-list',
            name: 'List Events ',
            component: EventList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
    ],
};
const careerRoute = {
    name: 'Careers',
    icon: FeatherIcon.Archive,
    children: [],
};
// const memberRoute = {
//     name: 'Council Members',
//     icon: FeatherIcon.Archive,
//     roles: [9],
//     children: [
//         {
//             path: '/council-list',
//             name: 'List Members ',
//             component: NewMember,
//             route: PrivateRoute,
//             roles: [9],
//         },
//     ],
// };
const homeRoute = {
    name: 'Home',
    icon: FeatherIcon.Archive,
    roles: [9],
    children: [
        {
            path: '/testimonials-list',
            name: 'Testimonials',
            component: NewTestimonial,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/banner-list',
            name: 'Banners',
            component: NewBanner,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/partners-list',
            name: 'Partners ',
            component: NewPartner,
            route: PrivateRoute,
            roles: [9],

        },
    ],
};
const aboutUsRoute = {
    name: 'About Us',
    icon: FeatherIcon.Archive,
    roles: [9],
    children: [
        {
            path: '/about_kied',
            name: 'About KIED',
            component: AboutKied,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/council_members',
            name: 'Governing Council Members',
            component: NewMember,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/our_team',
            name: 'Our Team',
            component: OurTeam,
            route: PrivateRoute,
            roles: [9],
        },
        // {
        //     path: '/contact_us',
        //     name: 'Contact Us',
        //     component: NewTestimonial,
        //     route: PrivateRoute,
        //     roles: [9],
        // },
    ],
};
const reportChildren = [
    // Programs Report - for Program/Learning department admins and Super Admin
    ...(isSuperAdmin || showProgramReport
        ? [
            {
                path: '/program_report',
                name: 'Programs',
                component: ProgramReportsList,
                route: PrivateRoute,
                roles: [9, 12],
            },
        ]
        : []),
    // Events Report - available to all
    {
        path: '/events_report',
        name: 'Events',
        component: EventsReportsList,
        route: PrivateRoute,
        roles: [9, 12],
    },
    // Internship Report - available to Super Admin and other departments (not Program/Learning)
    ...(isSuperAdmin || (!showProgramReport)
        ? [
            {
                path: '/internship_report',
                name: 'Internship',
                component: InternshipReportsList,
                route: PrivateRoute,
                roles: [9, 12],
            },
        ]
        : []),
    // Industry Academic Report - for Industry Academic department admins and Super Admin
    ...(isSuperAdmin || showIndustryAcademicReport
        ? [
            {
                path: '/industry_academic_report',
                name: 'Industry Academic',
                component: IndustryAcademicReportsList,
                route: PrivateRoute,
                roles: [9, 12],
            },
        ]
        : []),
    // Facilitation Report - for Facilitation department admins and Super Admin
    ...(isSuperAdmin || showFacilitationReport
        ? [
            {
                path: '/facilitation_report',
                name: 'Facilitation',
                component: FacilitationReportsList,
                route: PrivateRoute,
                roles: [9, 12],
            },
        ]
        : []),
    // Incubation Report - for Incubation department admins and Super Admin
    ...(isSuperAdmin || showIncubationReport
        ? [
            {
                path: '/incubation_report_list',
                name: 'Incubation',
                component: IncubationReportsList,
                route: PrivateRoute,
                roles: [9, 12],
            },
        ]
        : []),
];

const ReportsRoute = {
    name: 'Reports',
    icon: FeatherIcon.Archive,
    roles: [9, 12],
    children: reportChildren,
};

const incubationReportRoute = {
    icon: FeatherIcon.Archive,
    path: '/incubation_report_list',
    name: 'Incubation Report',
    component: IncubationReportsList,
    route: PrivateRoute,
    roles: [9, 12],
};
const facilitationReportRoute = {
    icon: FeatherIcon.Archive,
    path: '/facilitation_report',
    name: 'Facilitation Report',
    component: FacilitationReportsList,
    route: PrivateRoute,
    roles: [9, 12],
};
const industryAcademicReportRoute = {
    icon: FeatherIcon.Archive,
    path: '/industry_academic_report',
    name: 'Industry Academic Report',
    component: IndustryAcademicReportsList,
    route: PrivateRoute,
    roles: [9, 12],
};
const programReportRoute = {
    icon: FeatherIcon.Archive,
    path: '/program_report',
    name: 'Program Report',
    component: ProgramReportsList,
    route: PrivateRoute,
    roles: [9, 12],
};

const tenderRoute = {
    name: 'Information',
    icon: FeatherIcon.Archive,
    roles: [9],
    children: [
        {
            path: '/tender-list',
            name: 'Tenders ',
            component: NewTender,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/career-list',
            name: 'Careers ',
            component: NewCareer,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/grievance-redressal-list',
            name: 'Grievance Redressal',
            component: GrievanceRedressal,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/rti-list',
            name: 'RTI',
            component: RTI,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/orders-list',
            name: 'Acts, Rules And Government Orders',
            component: ActsRulesAndGOs,
            route: PrivateRoute,
            roles: [9],
        },

        {
            path: '/internship-list',
            name: 'Internship',
            component: AdminInternshipList,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/internship-application-list',
            name: 'Internship Applications',
            component: InternshipApplicationList,
            route: PrivateRoute,
            roles: [9],
        },

    ],
};
const resourceRoute = {
    name: 'Resources',
    icon: FeatherIcon.Archive,
    roles: [9],
    children: [
        {
            path: '/material-list',
            name: 'Materials ',
            component: NewMaterial,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/video-list',
            name: 'Videos ',
            component: NewVideos,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/publications-list',
            name: 'Publications and Newsletters',
            component: NewApplications,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/report-list',
            name: 'Annual Reports',
            component: NewReports,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/photos-list',
            name: 'Photos ',
            component: NewPhotos,
            route: PrivateRoute,
            roles: [9],
        },

        {
            path: '/advertisement-list',
            name: 'Advertisement',
            component: AdvertisementList,
            route: PrivateRoute,
            roles: [9],
        },
    ],
};
const facilitationRoute = {
    icon: FeatherIcon.Archive,
    path: '/facilitation-list',
    name: 'Facilitation',
    component: FacilitationList,
    route: PrivateRoute,
    roles: [9, 12, 13, 14, 15, 16],
};
const incubationRoute = {
    icon: FeatherIcon.Archive,
    path: '/incubation-application-list',
    name: 'Incubation',
    component: IncubationApplicationList,
    route: PrivateRoute,
    roles: [9, 12],
};
const industryAcademicRoute = {
    icon: FeatherIcon.Archive,
    path: '/industry-academic-list',
    name: 'Industry Academic Collaboration',
    component: AcademicList,
    route: PrivateRoute,
    roles: [9, 12],
};

const departmentRoute = {
    name: 'Departments',
    icon: FeatherIcon.Archive,
    roles: [9],
    children: [
        {
            path: '/department-list',
            name: 'List Departments',
            component: DepartmentList,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/industry-academic-list',
            name: 'Industry Academic Collaboration',
            component: AcademicList,
            route: PrivateRoute,
            roles: [9, 12],
        },
        {
            path: '/facilitation-list',
            name: 'Facilitation',
            component: FacilitationList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/incubation-application-list',
            name: 'Incubation',
            component: IncubationApplicationList,
            route: PrivateRoute,
            roles: [9, 12],
        },

    ],
};
const newsRoute = {
    name: 'Latest News',
    icon: FeatherIcon.Archive,
    roles: [9],
    children: [
        {
            path: '/news-list',
            name: 'All News ',
            component: NewsList,
            route: PrivateRoute,
            roles: [9],
        },
    ],
};
const schemeRoute = {
    name: 'Schemes',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/scheme-list',
            name: 'List Schemes ',
            component: SchemeList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
    ],
};
// const materialRoute = {
//     name: 'Materials',
//     icon: FeatherIcon.Archive,
//     children: [
//         {
//             path: '/scheme-list',
//             name: 'List Schemes ',
//             component: SchemeList,
//             route: PrivateRoute,
//             roles: [9],
//         },
//     ],
// };
const LearningRoute = {
    name: 'Programs',
    roles: [12],
    icon: FeatherIcon.Archive,
    path: '/program-list',
    component: ProgramList,
    route: PrivateRoute,
};

const ProgramRoute = {
    name: 'Programmes',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/program-list',
            name: 'Program list ',
            component: ProgramList,
            route: PrivateRoute,
            roles: [9, 12],
        },
        {
            path: '/program-feedback',
            name: 'Program Feedback',
            component: FeedbackList,
            route: PrivateRoute,
            roles: [9, 12],
        },
        ...(loggedInForDept?.role === 9 ? [
            {
                path: '/newprogram-list',
                name: 'New Program',
                component: NewProgram,
                route: PrivateRoute,
                roles: [9, 12],
            },
        ] : []),
    ],
};
const edcRoute = {
    name: 'EDC',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/incubation-registration-list',
            name: 'Yuva Bootcamp',
            component: IncubationList,
            route: PrivateRoute,
            roles: [9],
        },
        {
            path: '/arise-registration-list',
            name: 'Online Entrepreneurship Program',
            component: AriseList,
            route: PrivateRoute,
            roles: [9],
        },
    ],
};
const Users = {
    name: 'Users',
    icon: FeatherIcon.Archive,
    children: [
        {
            path: '/aspiring-user-list',
            name: 'Aspiring Entrepreneurs',
            component: AspiringUser,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 2,
        },
        {
            path: '/schools-colleges-list',
            name: 'Schools & Colleges',
            component: SchoolDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 3,
        },
        {
            path: '/existing-list',
            name: 'Existing Entrepreneurs',
            component: ExistingUser,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 4,
        },
        {
            path: '/research-list',
            name: 'Research & Academic Institutions',
            component: ResearchUser,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 5,
        },
        {
            path: '/industry-list',
            name: 'Industry Associations',
            component: IndustryList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 6,
        },
        {
            path: '/expert-list',
            name: 'Experts & Mentors',
            component: ExpertList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 7,
        },
        {
            path: '/edclub-list',
            name: 'ED Club',
            component: EDClubList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 8,
        },
        {
            path: '/student-list',
            name: 'Students',
            component: StudentList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 9,
        },
        {
            path: '/guest-list',
            name: 'Guest',
            component: GuestList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
            perm: 10,
        },
    ],
};
const newUser = {
    name: 'Admin',
    icon: FeatherIcon.Archive,
    roles: [9, 12],
    children: [
        {
            path: '/newuser-list',
            name: 'New User',
            component: NewUserList,
            route: PrivateRoute,
            roles: [9, 12],
        },
    ],
};
const districts = {
    name: 'Districts',
    icon: FeatherIcon.Archive,
    roles: [9],
    children: [
        {
            path: '/district-list',
            name: 'Districts List',
            component: districtList,
            route: PrivateRoute,
            roles: [9, 15, 16],
        },
    ],
};

const authRoutes = {
    path: '/account',
    name: 'Auth',
    children: [
        {
            path: '/account/login',
            name: 'Login',
            component: Login,
            route: Route,
        },
        {
            path: '/account/logout',
            name: 'Logout',
            component: Logout,
            route: Route,
        },
        {
            path: '/account/register',
            name: 'Register',
            component: Register,
            route: Route,
        },
        {
            path: '/account/confirm',
            name: 'Confirm',
            component: Confirm,
            route: Route,
        },
        {
            path: '/account/forget-password',
            name: 'Forget Password',
            component: ForgetPassword,
            route: Route,
        },
    ],
};

const flattenRoutes = (routes) => {
    let flatRoutes = [
        {
            path: '/incubation-detail/:id',
            component: IncubationDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/arise-detail/:id',
            component: AriseDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/acceleration-detail/:id',
            component: AccelerationDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/aspiring-detail/:id',
            component: AspiringDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/school-detail/:id',
            component: SchoolList,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/existing-detail/:id',
            component: ExistingDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },

        {
            path: '/research-detail/:id',
            component: ResearchDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/industry-detail/:id',
            component: IndustryDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/expert-detail/:id',
            component: ExpertDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/matchmaking-detail/:id',
            component: MatchDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        // {
        //     path: '/internship-detail/:id',
        //     component: InternshipDetails,
        //     route: PrivateRoute,
        //     roles: [9, 12, 13, 14, 15, 16],
        // },
        {
            path: '/event-detail/:id',
            component: EventDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/grievance-redressal-detail/:id',
            component: GrievanceRedressalDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/incubation-detail/:id',
            component: IncubationDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/industry-academic-detail/:id',
            component: AcademicDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/facilitation-details/:id',
            component: FacilitationDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/scheme-detail/:id',
            component: SchemeDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/program-detail/:id',
            component: ProgramDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/program-reports-detail/:id',
            component: ProgramReportsDetail,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/events-reports-detail/:id',
            component: EventsReportsDetail,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/internship-reports-detail/:id',
            component: InternshipReportsDetail,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/incubation-reports-detail/:id',
            component: IncubationReportsDetail,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/facilitation-reports-detail/:id',
            component: FacilitationReportsDetail,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/industry-academic-reports-detail/:id',
            component: IndustryAcademicReportsDetail,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/program-booking-detail/:id/:uid',
            component: ProgramBookingDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/news-detail/:id',
            component: NewsDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/Internship-detail/:id',
            component: AdminInternshipDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/publication-details/:id',
            component: PublicationDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/Internship-application-detail/:id',
            component: InternshipApplicationDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/department-detail/:id',
            component: DepartmentDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/edit-program/:id',
            component: EditProgram,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/edclub-detail/:id',
            component: EDClubDetails,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
        {
            path: '/banner-detail/:id',
            component: BannerDetail,
            route: PrivateRoute,
            roles: [9, 12, 13, 14, 15, 16],
        },
    ];

    routes = routes || [];
    routes.forEach((item) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

const appRoutes = [
    Users,
    // edcRoute,
    newUser,
    // edclubRoute,
    eventRoute,
    schemeRoute,
    // ProgramRoute,
    ...(showAdminProgram ? [ProgramRoute] : []),
    // incubationRoute,
    // iacRoute,
    newsRoute,
    resourceRoute,
    tenderRoute,
    // memberRoute,
    homeRoute,
    departmentRoute,
    // Department-specific listing menus for department admins
    ...(showFacilitation ? [facilitationRoute] : []),
    ...(showIncubation ? [incubationRoute] : []),
    ...(showIndustryAcademic ? [industryAcademicRoute] : []),
    // Note: Learning/Program department uses ProgramRoute via showAdminProgram

    districts,
    questionRoute,
    // GrievanceRedressal,
    aboutUsRoute,
    // Reports section - shows appropriate reports for each department admin
    ReportsRoute,
];

const allRoutes = [rootRoute, dashboardRoutes, ...appRoutes, authRoutes];

const authProtectedRoutes = [dashboardRoutes, ...appRoutes];
const allFlattenRoutes = flattenRoutes(allRoutes);
export { allRoutes, authProtectedRoutes, allFlattenRoutes };
